import { gpHome } from '../../app';
import { AnalysisProjectBackgroundTask } from '../../services/analysis-contract';
import analysisTaskListTemplate from './analysis-task-list.html';

class AnalysisTaskListComponent {

    tasks!: AnalysisProjectBackgroundTask[];
    selectedTask!: AnalysisProjectBackgroundTask | null;
    onTaskClick!: (args: { task: AnalysisProjectBackgroundTask }) => void;

    getStatusIcon(task: AnalysisProjectBackgroundTask): string {
        switch (task.status) {
            case 'running': return 'fa-spinner fa-spin';
            case 'complete': return 'fa-check';
            case 'error': return 'fa-exclamation-triangle';
            case 'pending': return 'fa-clock-o';
            default: return 'fa-circle-o';
        }
    }

    getStatusClass(task: AnalysisProjectBackgroundTask): string {
        return 'task-status-' + task.status;
    }

    isSelected(task: AnalysisProjectBackgroundTask): boolean {
        return this.selectedTask !== null && this.selectedTask !== undefined && this.selectedTask.id === task.id;
    }

    handleClick(task: AnalysisProjectBackgroundTask): void {
        if (this.onTaskClick) {
            this.onTaskClick({ task });
        }
    }
}

gpHome.component('gpAnalysisTaskList', {
    template: analysisTaskListTemplate,
    controller: AnalysisTaskListComponent,
    bindings: {
        tasks: '<',
        selectedTask: '<',
        onTaskClick: '&',
    },
});
